import { Fragment } from 'react';
import { IqMessengerConnection } from './IqMessengerConnection';

export const IqMessengerConnections = ({ connections, handleDelete, handleEdit }) => {
   
    const renderConnections = () => {
        const connectionsRendered = connections.map(connection => {
            return <IqMessengerConnection key={connection.id} connection={connection} handleDelete={handleDelete} handleEdit={handleEdit}/>
        });
        
        return <Fragment>
                {connectionsRendered}
            </Fragment>;
    }

    return (
        <div>
            <table className="table table-striped table-bordered my-2">
                <thead className="thead-dark">
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Client ID</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {renderConnections()}
                </tbody>
            </table>           
        </div>
    )
}